import React, { Component } from 'react';
import "./style.css"

class App extends Component {

  
    render() {
        return (
            <div style={{ position: "relative" }} className={"Crumb"}>
                <span>{this.props.title}</span>
            </div>
        );
    }
}
export default App


// WEBPACK FOOTER //
// ./src/components/Content/Crumbs/Crumbs.js